/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiNote } from './ApiNote';
import {
    ApiNoteFromJSON,
    ApiNoteFromJSONTyped,
    ApiNoteToJSON,
    ApiNoteToJSONTyped,
} from './ApiNote';

/**
 * 
 * @export
 * @interface NotesPage
 */
export interface NotesPage {
    /**
     * 
     * @type {number}
     * @memberof NotesPage
     */
    number: number;
    /**
     * 
     * @type {number}
     * @memberof NotesPage
     */
    size: number;
    /**
     * 
     * @type {number}
     * @memberof NotesPage
     */
    total: number;
    /**
     * 
     * @type {Array<ApiNote>}
     * @memberof NotesPage
     */
    content: Array<ApiNote>;
}

/**
 * Check if a given object implements the NotesPage interface.
 */
export function instanceOfNotesPage(value: object): value is NotesPage {
    if (!('number' in value) || value['number'] === undefined) return false;
    if (!('size' in value) || value['size'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('content' in value) || value['content'] === undefined) return false;
    return true;
}

export function NotesPageFromJSON(json: any): NotesPage {
    return NotesPageFromJSONTyped(json, false);
}

export function NotesPageFromJSONTyped(json: any, ignoreDiscriminator: boolean): NotesPage {
    if (json == null) {
        return json;
    }
    return {
        
        'number': json['number'],
        'size': json['size'],
        'total': json['total'],
        'content': ((json['content'] as Array<any>).map(ApiNoteFromJSON)),
    };
}

export function NotesPageToJSON(json: any): NotesPage {
    return NotesPageToJSONTyped(json, false);
}

export function NotesPageToJSONTyped(value?: NotesPage | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'number': value['number'],
        'size': value['size'],
        'total': value['total'],
        'content': ((value['content'] as Array<any>).map(ApiNoteToJSON)),
    };
}

